import React from "react";
import { useLocalization } from "@fluent/react";
import { translateSupportLinks } from "byzantine/src/l10n/SettingLocalizers";
import type { SupportLink } from "byzantine/src/types/SettingLocalizers.types";

export default function QuickLinkList({ links }: { links: SupportLink[] }) {
  const { l10n } = useLocalization();
  const translatedLinks = translateSupportLinks(links, l10n);
  return (
    <div className="quick-links-list">
      <div className="support-section-title">
        {l10n.getString("heading-support-links")}
      </div>
      <div className="card">
        {translatedLinks.map((link, index) => (
          <div key={`${link.text}${link.url}`} className="quick-link-item">
            <a
              data-testid={`support-quick-link-${index}`}
              href={link.url}
              target="_blank"
              rel="noreferrer"
            >
              {link.text}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
